export const DATA_IMPORT_HREF = {
	labInventory: '../../../LabInventoryDataTemplate.xlsx',
	rack: '../../../RackInfo.xlsx',
	switch: '../../../NetworkSwitchInventory.xlsx',
};

export const DATA_IMPORT_TYPES = {
	switch: 'Switch',
	rack: 'Rack',
	labInventory: 'Lab Inventory',
};